/* TODO[DELETE-MOCKS]: 실 API 연결 시 삭제 */

export const mockUser = {
  id: 'user_demo',
  username: 'jieun_lash',
  shopName: '홍대 지은 래쉬',
  region: '서울 마포구 홍대입구',
  instagramFollowers: 2843,
  imageUrl:
    '/mock-images/profile/user.jpg',
  planTier: 'pro' as const,
  credits: 142,
  creditsMax: 150,
  nextChargeAt: '2026-05-20',
  createdAt: '2026-01-18T10:23:00Z',
};
